import { clearMediaBlobUrlCache } from '@/utils/media-cache';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

/** Clear all request, blob and registered preview caches before auth changes. */
export const useClearClientCache = () => {
  const queryClient = useQueryClient();

  return useCallback(() => {
    clearMediaBlobUrlCache();
    queryClient.clear();
  }, [queryClient]);
};
